import { render, staticRenderFns } from "./cpdActivityCategory.vue?vue&type=template&id=4c3151f5&scoped=true"
import script from "./cpdActivityCategory.vue?vue&type=script&lang=js"
export * from "./cpdActivityCategory.vue?vue&type=script&lang=js"
import style0 from "./cpdActivityCategory.vue?vue&type=style&index=0&id=4c3151f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3151f5",
  null
  
)

export default component.exports